import { motion } from 'framer-motion';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function PrivacyPolicyPage() {
  return (
    <>
      <Navigation />
      
      {/* Hero */}
      <section className="relative pt-32 pb-16 bg-[#111111]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span
              className="text-[#00E5FF] text-xs tracking-[0.3em] uppercase font-semibold"
              style={{ fontFamily: 'Orbitron, sans-serif' }}
            >
              Dokumenty prawne
            </span>
            <h1
              className="text-4xl sm:text-5xl font-bold text-white mt-4 mb-6"
              style={{ fontFamily: 'Rajdhani, sans-serif' }}
            >
              Polityka <span className="text-[#00E5FF]">Prywatności</span>
            </h1>
            <div className="h-[2px] w-20 bg-[#00E5FF]"></div>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-[#0A0A0A]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="prose prose-invert max-w-none"
          >
            <div className="space-y-8 text-[#C0C7CF]" style={{ fontFamily: 'Inter, sans-serif' }}>
              
              <div>
                <h2 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
                  1. Administrator danych osobowych
                </h2>
                <p className="text-sm leading-relaxed">
                  Administratorem danych osobowych jest Przedsiębiorstwo Wielobranżowe EUREKA, Zabłotce 146, 38-500 Sanok, tel. +48 600 978 050, e-mail: jgladysz@eureka.sanok.pl
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
                  2. Zakres przetwarzanych danych
                </h2>
                <p className="text-sm leading-relaxed mb-3">
                  W ramach prowadzonej działalności przetwarzamy następujące kategorie danych osobowych:
                </p>
                <ul className="list-disc list-inside space-y-2 text-sm ml-4">
                  <li>Dane identyfikacyjne (imię, nazwisko)</li>
                  <li>Dane kontaktowe (adres e-mail, numer telefonu)</li>
                  <li>Dane dotyczące korespondencji i komunikacji</li>
                  <li>Dane techniczne (adres IP, typ przeglądarki, system operacyjny)</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
                  3. Cel i podstawa prawna przetwarzania
                </h2>
                <p className="text-sm leading-relaxed mb-3">
                  Dane osobowe przetwarzane są w następujących celach:
                </p>
                <ul className="list-disc list-inside space-y-2 text-sm ml-4">
                  <li>Obsługa zapytań ofertowych i kontakt z klientami (art. 6 ust. 1 lit. b RODO)</li>
                  <li>Marketing bezpośredni produktów i usług (art. 6 ust. 1 lit. f RODO)</li>
                  <li>Wypełnienie obowiązków prawnych (art. 6 ust. 1 lit. c RODO)</li>
                  <li>Analiza statystyk strony internetowej (art. 6 ust. 1 lit. f RODO)</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
                  4. Okres przechowywania danych
                </h2>
                <p className="text-sm leading-relaxed">
                  Dane osobowe przechowywane są przez okres niezbędny do realizacji celów, dla których zostały zebrane, a następnie przez okres wymagany przepisami prawa lub do czasu wycofania zgody.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
                  5. Odbiorcy danych
                </h2>
                <p className="text-sm leading-relaxed">
                  Dane osobowe mogą być przekazywane podmiotom współpracującym z Administratorem w zakresie niezbędnym do realizacji usług, w tym dostawcom usług IT, księgowym, prawnym oraz kurierom.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
                  6. Prawa osób, których dane dotyczą
                </h2>
                <p className="text-sm leading-relaxed mb-3">
                  Przysługuje Państwu prawo do:
                </p>
                <ul className="list-disc list-inside space-y-2 text-sm ml-4">
                  <li>Dostępu do swoich danych osobowych</li>
                  <li>Sprostowania danych</li>
                  <li>Usunięcia danych</li>
                  <li>Ograniczenia przetwarzania</li>
                  <li>Przenoszenia danych</li>
                  <li>Wniesienia sprzeciwu wobec przetwarzania</li>
                  <li>Cofnięcia zgody w dowolnym momencie</li>
                  <li>Wniesienia skargi do organu nadzorczego (UODO)</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
                  7. Pliki cookies
                </h2>
                <p className="text-sm leading-relaxed mb-3">
                  Nasza strona internetowa wykorzystuje pliki cookies w celu:
                </p>
                <ul className="list-disc list-inside space-y-2 text-sm ml-4">
                  <li>Zapewnienia prawidłowego działania strony</li>
                  <li>Dostosowania zawartości do preferencji użytkownika</li>
                  <li>Tworzenia statystyk i analiz ruchu na stronie</li>
                  <li>Zapamiętywania ustawień użytkownika</li>
                </ul>
                <p className="text-sm leading-relaxed mt-3">
                  Użytkownik może w każdej chwili zmienić ustawienia dotyczące plików cookies w swojej przeglądarce internetowej. Wyłączenie cookies może wpłynąć na funkcjonalność strony.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
                  8. Bezpieczeństwo danych
                </h2>
                <p className="text-sm leading-relaxed">
                  Administrator stosuje odpowiednie środki techniczne i organizacyjne zapewniające ochronę przetwarzanych danych osobowych odpowiednią do zagrożeń oraz kategorii danych objętych ochroną.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
                  9. Kontakt
                </h2>
                <p className="text-sm leading-relaxed">
                  W sprawach dotyczących ochrony danych osobowych prosimy o kontakt:<br />
                  E-mail: <a href="mailto:jgladysz@eureka.sanok.pl" className="text-[#00E5FF] hover:underline">jgladysz@eureka.sanok.pl</a><br />
                  Telefon: <a href="tel:+48600978050" className="text-[#00E5FF] hover:underline">+48 600 978 050</a>
                </p>
              </div>

              <div className="pt-6 border-t border-[#00E5FF]/20">
                <p className="text-xs text-[#C0C7CF]/70">
                  Ostatnia aktualizacja: {new Date().toLocaleDateString('pl-PL')}
                </p>
              </div>

            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </>
  );
}
